<template>
    <v-app>
        <portal-sysbar></portal-sysbar>
        <div class="main-content">
          <portal-aside></portal-aside>
          <portal-title
            :title="$t('message.aside.battery', { value: 'default' })"
          ></portal-title>
          <portal-breadcumb></portal-breadcumb>

          <div class="content">
            <v-row>

              <v-col class="d-flex" cols="12" sm="2" >
                <v-autocomplete
                  v-model="level"
                  :items="levels"
                  label="Level"
                  item-value="levelvalue"
                  item-text="levelname"
                  outlined
                  dense
                  @change="refreshBatteryDataTable"
                >
                </v-autocomplete>
              </v-col>              

              <v-col class="d-flex" cols="12" sm="2" >
                <v-autocomplete
                  :items="locoList"
                  @change="refreshGraph"
                  :label="$t('message.pageKm.loco', { value: 'default' })"
                  item-value="loconum"
                  item-text="loconum"
                  outlined
                  dense
                  v-model="payload.locomotives"
                  v-show="false"
                >
                </v-autocomplete>
              </v-col>

              <v-col class="d-flex" cols="12" sm="2">
                <v-menu
                  v-model="startDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :label="$t('message.page.startDate', { value: 'default' })"
                      readonly
                      :value="startDateDisp"
                      v-on="on"
                      outlined
                      dense
                      v-show="false"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="startDateVal"
                    no-title
                    @input="startDateMenu = false"
                    @change="refreshData"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="d-flex" cols="12" sm="2">
                <v-menu
                  v-model="endDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :label="$t('message.page.endDate', { value: 'default' })"
                      readonly
                      :value="endDateDisp"
                      v-on="on"
                      outlined
                      dense
                      v-show="false"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="endDateVal"
                    no-title
                    @input="endDateMenu = false"
                    @change="refreshData"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row> 
        
            <div class="text-center" v-show="this.progress.chart">
              <v-progress-circular
                :size="50"
                color="#EEBB07"
                indeterminate
              ></v-progress-circular>
            </div>          

            <apex-charts
              height="274"
              :options="chartOptions"
              :series="series"
              ref="chart"
              v-show="this.progress.graph"
            >
            </apex-charts>

            <v-row class="mb-5">
              <v-col>
                <v-card>
                  <v-card-title class="portal-deep-blue-bg">
                    {{ $t("message.aside.batterytable", { value: "default" }) }}
                    <v-icon color="#fff" class="ml-auto"> mdi-train </v-icon>
                  </v-card-title>
                </v-card>

                <v-data-table
                  :headers="headersTable"
                  :items="datasTable"
                  class="elevation-1 km"
                  hide-default-header
                  :loading="progress.avgData"
                  :loading-text="$t('message.loadingText', { value: 'default' })"
                >

                  <template v-slot:header="{ props: { headers } }">
                      <thead>
                        <tr>
                          <th
                            style="cursor: pointer"
                            v-for="item in headers"
                            :key="item.value" 
                          >
                            {{item.text}}
                          </th>
                        </tr>
                      </thead>
                  </template>   
                  
                  <template v-slot:[`item.percentageBattery`]="{ item }">
                    <v-chip :color="getColor(item.percentageBattery)">
                      {{ item.percentageBattery }} %
                    </v-chip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </div>
        </div>
    </v-app>
</template>

<script>
import PortalSysbar from "@/components/PortalSysbar";
import PortalAside from "@/components/PortalAside";
import PortalTitle from "@/components/PortalTitle";
import PortalBreadcumb from "@/components/PortalBreadcumb";
import ApexCharts from "vue-apexcharts";
import { mapActions, mapGetters } from "vuex";
import {
  firstDateOfCurrentMonth,
  currentDate,
  parseDate,
  parseEndDate,
  formatDate,
  numStr,
  formatSinceDate,
  formatInfoDate
} from "@/shared/DateHelper";

import CascService from "@/services/CascService";
import TeamsService from "@/services/TeamsService";
import moment from "moment-timezone";

export default {
  title: "Info batterys",
  watch: {
    getterCurrentClient: function () {
      this.initializeDates();
      this.initalizePayload();
      this.refreshData();
    },

    "$i18n.locale": function () {
      this.displaySinceDate();
      this.getLocoBatterysLevelForCustomer();
    },
  },

  methods: {

    name: "InfoBatteryPage",

    ...mapActions("customer", {
      actionGetLocos: "loadLocos",
    }),

    displaySinceDate() {
      this.sinceDate = formatSinceDate(
        this.payload.startdate,
        this.$i18n.locale
      );
    },

    toggle() {
      this.$nextTick(() => {
        if (this.selectAllLoc) {
          this.payload.locomotives = [];
        } else {
          this.payload.locomotives = this.extractLoco(this.locoList);
          this.refreshData();
        }
      });
    },

    formatDistance(value) {
      return numStr(value);
    },

    async loadLocos() {
      let payload = {
        customer: this.getterCurrentClient,
        start: firstDateOfCurrentMonth(),
        end: currentDate(),
      };
      await this.actionGetLocos(payload);
      this.getLocoBatterysLevelForCustomer();
    },

    async refreshData() {
      this.payload.enddate = parseEndDate(this.endDateVal);
      this.payload.startdate = parseDate(this.startDateVal);
      this.loadLocos();
      
    },

    async refreshGraph(){
      this.payload.enddate = parseEndDate(this.endDateVal);
      let start = new Date(this.endDateVal);
      this.payload.startdate = moment(start.addDays(-2)).format();
      this.startDateVal =  this.payload.startdate.substr(0,10);
      this.payload.startdate = parseDate(this.startDateVal);
      let locos = [];
      let tp = this.payload.locomotives;
      locos.push(this.payload.locomotives);
      this.payload.locomotives = locos;
      this.getChartDatas();
      this.payload.locomotives = tp;
    },

    refreshBatteryDataTable(){
      console.log(this.level);
      var i;
      let listOut = [];
      
      for (i = 0; i < this.datasTableLevel.length; i++) {

        if (this.level == 'All') {
          listOut.push(this.datasTableLevel[i]);
        } else if (this.level == 'Normal' && this.datasTableLevel[i].percentageBattery >= 75 && this.datasTableLevel[i].percentageBattery <= 100) {
          listOut.push(this.datasTableLevel[i]);
        } else if (this.level == 'Alert' && this.datasTableLevel[i].percentageBattery >= 67 && this.datasTableLevel[i].percentageBattery <= 74) {
          listOut.push(this.datasTableLevel[i]);
        } else if (this.level == 'Critical' && this.datasTableLevel[i].percentageBattery >= 0 && this.datasTableLevel[i].percentageBattery <= 66) {
          listOut.push(this.datasTableLevel[i]);
        } 
      }
      console.log(listOut);
      this.datasTable = listOut;
      this.sortedListPercentageBattery();
    }, 

    async getAlertAndCritical(serial, locosData) {
      TeamsService.getConfigsForSerial(serial).then((resp) => {
        let ret = resp.data;
        this.salert = ret[0].value;
        this.scritical = ret[1].value;
        var i;
        var data = [];

        this.chartOptions.xaxis.categories.splice(
          0,
          this.chartOptions.xaxis.categories.length
        );

        for (i = 0; i < locosData.length; i++) {
          data.push(locosData[i].battery);
          this.chartOptions.xaxis.categories.push(locosData[i].datetime);
        }

        this.$refs.chart.updateSeries([
          {
            name: this.$t("message.pageBattery.batteryLevel", { value: "default" }),
            data: data,
          },
        ]);
        this.progress.chart = false;
        this.progress.graph = true;
        this.chartOptions.annotations.yaxis[1].y = this.salert;
        this.chartOptions.annotations.yaxis[0].y = this.scritical;
      })
    },

    getLocoBatterysLevelForCustomer(){
        this.progress.avgData = true;
        CascService.getLocoBatterysLevelForCustomer(this.payload)
        .then((response) => {
          this.datasTable = this.getLocoBatterysLevelForCustomerDatas(response.data);
          //we apply a filter to order ascent list (order by precentageBattery)
          this.sortedListPercentageBattery();
          this.datasTableLevel = this.datasTable;
          this.progress.avgData = false;
        })
        .catch((err) => {
          console.log("GetTotalDistance:", err);
          this.datasTable = this.getLocoBatterysLevelForCustomerDatas([]);
          this.datasTableLevel = this.datasTable;
          this.progress.avgData = false;
        });
    },

    getLocoBatterysLevelForCustomerDatas(data){
      let list = [];
      var i;
      for (i = 0; i < this.getterLocos.length; i++) {
        let find = data.find(
          (e) => e.locomotive == this.getterLocos[i].loconum
        );
        if (find !== undefined) {
          list.push({
            locomotive: this.getterLocos[i].loconum,
            percentageBattery: find.percentageBattery,
            battery: find.battery + " V",
            datetime: formatInfoDate(find.datetime, this.$i18n.locale)
          });
        }
      }
      return list;
    },
    sortedListPercentageBattery(){
      let sortedList = this.datasTable;
      this.datasTable = sortedList.sort((a,b) => {
        let fa = a.percentageBattery, fb = b.percentageBattery;
        if (fa < fb) {
          return -1
        }
        if (fa > fb) {
          return 1
        }
        return 0
      })
    },
  
    getChartDatas() {
      this.progress.chart = true;
      CascService.getBatteriesLoco(this.payload)
        .then((response) => {
          let retour = response.data;
          this.getAlertAndCritical(retour[0].serial, retour);
        })
        .catch((error) => {
          console.log("GetChartData: ", error);
          this.progress.chart = false;
        });
    },

    initializeDates() {
      this.startDateVal = formatDate(firstDateOfCurrentMonth());
      this.endDateVal = formatDate(currentDate());
    },

    initalizePayload() {
      this.payload.startdate = firstDateOfCurrentMonth();
      this.payload.enddate = currentDate();
      this.payload.clients = [this.getterCurrentClient];
      this.payload.locomotives = [];
    },

    getColor (percentages) {
      if (percentages >= 75 && percentages <= 100) return 'green'
      else if (percentages >= 67 && percentages <= 74) return 'orange'
      else if (percentages >= 0 && percentages <= 66) return 'red'
    },
  },

  computed: {
    ...mapGetters("auth", {
      getterContrats: "getContrats",
      getterCurrentClient: "getCurrentClient",
      getterAuthData: "getAuthData",
    }),

    ...mapGetters("customer", {
      getterLocos: "getFilterLoc",
    }),

    selectAllLoc() {
      if (this.payload.locomotives == null) return false;
      return this.locoList.length === this.payload.locomotives.length;
    },

    selectSomeLoc() {
      if (this.payload.locomotives == null) return false;
      return this.payload.locomotives.length > 0 && !this.selectAllLoc;
    },

    icon() {
      if (this.selectAllLoc) return "mdi-close-box";
      if (this.selectSomeLoc) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },

    headersTable() {
      return [
        {
          text: "Locomotive",
          value: "locomotive",
        },
        {
          text: "Battery level (%)",
          value: "percentageBattery",
          key: "percentages"
        },        
        {
          text: "Battery level (V)",
          value: "battery",
        },
        {
          text: "Date and time of last reading",
          value: "datetime",
        },        
      ];
    },
    
    endDateDisp() {
      return this.endDateVal;
    },

    startDateDisp() {
      return this.startDateVal;
    },
  },

  mounted() {
    this.initializeDates();
    this.initalizePayload();
    this.loadLocos();
    this.items = this.getterLocos;
    this.locoList = this.getterLocos;
    this.progress.chart = false;
    this.progress.graph = false;
    this.ctb = 100;
  },
  data: () => ({
    payload: {
      startdate: null,
      enddate: null,
      clients: null,
      locomotives: null,
    },
    progress: {
      chart: true,
      graph: true,
      avgData: true,
      totalData: true,
    },
    level: 'All',
    levels: ['All','Normal','Alert','Critical'],  
    locoList: [],
    sinceDate: "",
    datasTable: [],
    datasTableLevel: [],
    locos: [],
    endDateVal: null,
    endDateMenu: false,
    startDateVal: null,
    startDateMenu: false,
    salert: 0,
    scritical: 0,
    series: [
      {
        name: "",
        data: [],
      }
    ],
    chartOptions: {
      chart: {
        type: "area",
        stacked: false,
        height: 350,
        redrawOnParentResize: true,
        zoom: {
          type: "x",
          enabled: true,
          autoScaleYaxis: true,
        },
        toolbar: {
          autoSelected: "zoom",
        },
      },

      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
      },
      markers: {
        size: 0,
      },
      fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.5,
            opacityTo: 0,
            stops: [0, 90, 100]
          },
      },      
      colors: ["#EEBB07"],
      xaxis: {
        type: "date",
        tickAmount: 24,
        categories: [],
        tickPlacement: "between",
        labels: {
          formatter: function (value) {
            if (value.length == 16) {
              const [month, day] = value.substr(5, 5).split("-");
              const [hour, min] =  value.substr(11, 5).split(":");
              return `${day}-${month} ${hour}:${min}`;
            }
          },
        },      
      },
      yaxis: {
        min: 15,
        max: 150,
        tickAmount: 9,
      },
      annotations: {
        yaxis: [
          {
            y: 0,
            borderColor: '#e30000',
            label: {
              borderColor: '#e30000',
              style: {
                color: '#fff',
                background: '#e30000'
              },
              text: 'Critical Threshold battery'
            }
          },
          {
            y: 0,
            borderColor: '#F39C12',
            label: {
              borderColor: '#F39C12',
              style: {
                color: '#fff',
                background: '#F39C12'
              },
              text: 'Alert Threshold battery'
            }
          }          
        ]
      },
      tooltip: {
        x: {
          format: "dd-MM-yy HH:mm",
        },
      },
    },    
  }),

  components: {
    PortalSysbar,
    PortalAside,
    PortalTitle,
    PortalBreadcumb,
    ApexCharts,
  },
};

</script>

<style scoped>
.portal-green-bg {
  height: 59px;
  color: #fff;
}

thead {
  background-color: #fafafa;
  color: #9faaaf;
}

tbody {
  color: #00475a;
  font-weight: bolder;
}

.portal-deep-blue-bg {
  height: 59px;
  color: #fff;
  text-transform: uppercase;
}
.km {
  color: #00475a !important;
}
</style>